import { render, staticRenderFns } from "./LectureFormEdit.vue?vue&type=template&id=31d53e0f&"
import script from "./LectureFormEdit.vue?vue&type=script&lang=ts&"
export * from "./LectureFormEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports